import { IViolation, Metamodel, Named, stringIsNullOrEmpty } from 'shell-models-lib';
import { DataFlowDatasetSettings } from './dataflow-dataset-settings';
import { DataFlowExpression } from '../dataflowexpression';
import { BooleanDataFlowType } from 'worker/app-workers/shared/models/dataflow-datatype';
import { initializeDataflowSink } from 'app/model/dataflow/dataflow-utils';
import { format } from '../../../../../External/logicapps-swagger/libs/shared/Utils';

export enum TableActionOption {
    None,
    Recreate,
    Truncate
}

@Metamodel.model({
    name: 'tabularTypeSettings'
})
export abstract class TabularTypeSettings extends DataFlowDatasetSettings {
    public useQuery: boolean;
    public supportDataFlowStoreProcedure?: boolean = false;
    public tableName: DataFlowExpression;
    public schemaName: DataFlowExpression;
    public query: DataFlowExpression;
    public tableActionOption: TableActionOption = TableActionOption.None;
    public isListOfKeyColumns: boolean = true;
    public useTmpDB = true;
    public stagingSchemaName: DataFlowExpression;
    @Metamodel.attribute({
        constraint: {
            validator: TabularTypeSettings.validateDatabaseName
        }
    })
    public databaseName: DataFlowExpression; // Need for tridentMdf flow as the Connection may not have database name - it is optional for Kusto Connection in Fabric

    public static validateDatabaseName(owner: TabularTypeSettings, value: DataFlowExpression): IViolation[] {
        const violations: IViolation[] = [];
        if (__IS_FABRIC_MDF__ && owner.isDatabaseNameRequired && (!owner.databaseName || stringIsNullOrEmpty(owner.databaseName.expression))) {
            violations.push({
                context: owner.transform,
                message: () => format(stringResources.RequiredTemplate, stringResources.ModelName_DatabaseName),
                redirectTo: {
                        entity: owner.owner as Named,
                        attribute: TabularTypeSettings.MODEL.attribute('databaseName')
                    }
            });
        }
        return violations;
    }

    /**
     * Override in subclasses that require a database name in Fabric MDF mode.
     */
    public get isDatabaseNameRequired(): boolean {
        return false;
    }

    public initialize(subFormat: string): void {
        this.useQuery = false;
        this.tableName = this.transform.createTemplatableExpression();
        this.schemaName = this.transform.createTemplatableExpression();
        this.query = this.transform.createTemplatableExpression();
        this.allowInsert = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'true');
        this.allowDelete = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
        this.allowUpsert = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
        this.allowUpdate = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
        this.keyColumns = [this.transform.createTemplatableExpression()];
        initializeDataflowSink(this);
        this.tableActionOption = TableActionOption.None;
        this.stagingSchemaName = this.transform.createTemplatableExpression();
        this.databaseName = this.transform.createTemplatableExpression();
    }
}
